import React, {PureComponent} from "react";
import {Field, formValueSelector} from "redux-form";
import InputField from "../forms/InputField";
import {connect} from "react-redux";
import {logout} from "../../actions/UserActions";
import {required, email} from "../../../form/components/forms/OrderForm/Validation";
import {Trans} from "react-i18next";
import Payment from "../order-form/Payment";

class Logout extends PureComponent {

    handleLogout = () => {
        this.props.logout();
    };

    render() {
        const {email} = this.props.user;

        return <div className="row">
            <div className="column">
                <span className="label"><Trans>E-mail</Trans></span>
                <div className="text-holder">
                    {email}
                </div>
            </div>
            <div className="column">
                <span className="label">&nbsp;</span>
                <a onClick={this.handleLogout} className="btn-login">
                    <Trans>LOGOUT</Trans>
                </a>
            </div>
        </div>
    }
}

export default connect(
    state => ({
        user: state.user,
    }),
    dispatch => ({
        logout: () => dispatch(logout())
    })
)(Logout);